import React from 'react';
import { experience } from '../data/content';

export default function Experience() {
  return (
    <section className="experience" id="experience">
      <p className="section-title">Experience</p>
      <h2>Professional Experience</h2>
      <div className="experience__list">
        {experience.map((job) => (
          <article key={job.company} className="experience__job">
            <div className="experience__header">
              <div className="experience__header-main">
                {job.logo && (
                  <div className="experience__logo-wrap">
                    <img
                      src={job.logo.startsWith('http') ? job.logo : process.env.PUBLIC_URL + job.logo}
                      alt=""
                      className="experience__logo"
                    />
                  </div>
                )}
                <div>
                  <h3>{job.company}</h3>
                  <p className="experience__tagline">{job.tagline}</p>
                </div>
              </div>
              <span className="experience__period">{job.period}</span>
            </div>
            {job.roles.map((role) => (
              <div key={role.title} className="experience__role">
                <p className="experience__role-title">
                  <strong>{role.title}</strong>
                  <span className="experience__stack">({role.stack})</span>
                </p>
                <ul>
                  {role.bullets.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </article>
        ))}
      </div>
    </section>
  );
}
